import { createDoc, getDocsOfOrgRef } from "db";
import { SHOW_ALERT, showAlertAction } from "./ui";
import { getDocsOfMemberRef } from "db";

export const DOC_ADD_OK = 'doc add ok';
export const DOC_ADD_FAIL = 'doc add fail';
export const FETCH_DOCS_OK = 'fetch docs ok';
export const FETCH_DOCS_FAIL = 'fetch docs fail';
export const FETCH_MEMBERS_DOCS_OK = 'fetch members docs ok';
export const FETCH_MEMBERS_DOCS_FAIL = 'fetch members docs fail';

export const createDocAction = (org_id, doc_id, params) => dispatch => {
  return createDoc(org_id, doc_id, params)
    .then(() => dispatch(
      {
        type: DOC_ADD_OK,
        payload: params
      }
    ))
    .catch(e => dispatch({
      type: DOC_ADD_FAIL,
      payload: e
    }))
}

export const getDocsOfMemberAction = (org_id, user_id) => dispatch => {
  return getDocsOfMemberRef(org_id, user_id)
    .onSnapshot(colSnap => {
      if (colSnap.size > 0) {
        dispatch({
          type: FETCH_MEMBERS_DOCS_OK,
          payload: { user_id, docs: colSnap.docs }
        })
      } else {
        dispatch({
          type: FETCH_MEMBERS_DOCS_OK,
          payload: { user_id, docs: [] }
        })
        dispatch(showAlertAction({
          message: "사례가 없습니다",
          color: 'danger',
        }))
      }
    }
      , e => {
        const message = e.code === 'permission-denied'
          ? '권한이 없습니다. 관리자에게 문의해주세요.'
          : `에러가 발생했습니다. ${e.message}`
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            message,
            color: 'danger',
          }
        })
      });
}

export const getDocsOfOrgAction = (org_id) => dispatch => {
  return getDocsOfOrgRef(org_id)
    .onSnapshot(colSnap => {
      if (colSnap.size > 0) {
        dispatch({
          type: FETCH_DOCS_OK,
          payload: colSnap.docs
        })
      } else {
        dispatch({
          type: FETCH_DOCS_OK,
          payload: []
        })
        dispatch(showAlertAction({
          message: "사례가 없습니다",
          color: 'danger',
        }))
      }
    }
      , e => {
        const message = e.code === 'permission-denied'
          ? '권한이 없습니다. 관리자에게 문의해주세요.'
          : `에러가 발생했습니다. ${e.message}`
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            message,
            color: 'danger',
          }
        })
      });
}
